import TurnstileContainer from "../../../Component/Application/turnstile/TurnstileContainer";

const TurnStilePage = () => {

    return (
        <div className="page-body">
            <TurnstileContainer/>
        </div>
    );
};

export default TurnStilePage;